<template>
  <div>
    <el-main>
      <el-container>
        <el-main class="content-wrapper">
          <div
            class="devdocumentIntroduce"
            v-if="mainHtml.showContent"
            v-html="mainHtml.content"
          >
          </div>
          <el-breadcrumb
            v-if="mainHtml.showBreadcrumnb"
            separator=">"
            separator-class="el-icon-arrow-right"
          >
            <el-breadcrumb-item
              v-for="(b, index) in mainHtml.breadcrumnbList"
              :key="index"
            >
              <span v-if="index + 1 !== mainHtml.breadcrumnbList.length">{{ b }}</span>
              <b v-else>{{ b }}</b>
            </el-breadcrumb-item>
          </el-breadcrumb>
          <!-- <h1 v-if="mainHtml.showInterfaceInfo">{{mainHtml.title}}</h1> -->
          <h1 class="subtitle" v-if="mainHtml.showInterfaceInfo">接口详情</h1>
          <el-table
            v-if="mainHtml.showInterfaceInfo"
            :data="mainHtml.interfaceInfoTable.tableData"
            header-row-class-name="my-header-row-class"
            border
            style="width: 100%"
          >
            <el-table-column
              v-for="(item, index) in mainHtml.interfaceInfoTable.tableHead"
              :key="index"
              :prop="item.prop"
              :width="item.width"
              :min-width="item.minWidth"
              :align="item.align"
              :label="item.label"
            >
            </el-table-column>
          </el-table>

          <h1 class="f16" v-if="mainHtml.showRequestHeadParams">
            <div class="subtitle">头部请求参数</div>
          </h1>
          <el-table
            v-if="mainHtml.showRequestHeadParams"
            :data="mainHtml.requestHeadParamsTable.tableData"
            header-row-class-name="my-header-row-class"
            border
            style="width: 100%"
          >
            <el-table-column
              v-for="(item, index) in mainHtml.requestHeadParamsTable.tableHead"
              :key="index"
              :prop="item.prop"
              :width="item.width"
              :min-width="item.minWidth"
              :align="item.align"
              :label="item.label"
            >
            </el-table-column>
          </el-table>

          <h1 class="f16" v-if="mainHtml.showYWRequestParamsTable">
            <div class="subtitle">业务请求参数</div>
          </h1>
          <el-table
            v-if="mainHtml.showYWRequestParamsTable"
            :data="mainHtml.yWRequestParamsTable.tableData"
            header-row-class-name="my-header-row-class"
            border
            style="width: 100%"
          >
            <el-table-column
              v-for="(item, index) in mainHtml.yWRequestParamsTable.tableHead"
              :key="index"
              :prop="item.prop"
              :width="item.width"
              :min-width="item.minWidth"
              :align="item.align"
              :label="item.label"
            >
            </el-table-column>
          </el-table>
          <div style="color: red" v-if="mainHtml.YWRequestParamsErrorInfo">
            {{ mainHtml.YWRequestParamsErrorInfo }}
          </div>
          <h1 class="f16" v-if="mainHtml.showResponseTable">
            <div class="subtitle">响应参数</div>
          </h1>
          <el-table
            v-if="mainHtml.showResponseTable"
            :data="mainHtml.responseTable.tableData"
            header-row-class-name="my-header-row-class"
            border
            style="width: 100%"
          >
            <el-table-column
              v-for="(item, index) in mainHtml.responseTable.tableHead"
              :key="index"
              :prop="item.prop"
              :width="item.width"
              :min-width="item.minWidth"
              :align="item.align"
              :label="item.label"
            >
            </el-table-column>
          </el-table>
          <h1 class="f16" v-if="mainHtml.showKeyIntroduct">
            <div class="subtitle">字段解释</div>
          </h1>
          <el-table
            v-if="mainHtml.showKeyIntroduct"
            :data="mainHtml.keyIntroductTable.tableData"
            header-row-class-name="my-header-row-class"
            border
            style="width: 100%"
          >
            <el-table-column
              v-for="(item, index) in mainHtml.keyIntroductTable.tableHead"
              :key="index"
              :prop="item.prop"
              :width="item.width"
              :min-width="item.minWidth"
              :align="item.align"
              :label="item.label"
            >
            </el-table-column>
          </el-table>
          <div style="color: red" v-if="mainHtml.keyIntroductErrorInfo">
            {{ mainHtml.keyIntroductErrorInfo }}
          </div>
          <h1 class="f16" v-if="mainHtml.showResponseCode">
            <div class="subtitle">响应示例</div>
          </h1>
          <div class="data" v-if="mainHtml.showResponseCode">
            <pre>
                  {{ mainHtml.responseCode }}
            </pre>
          </div>
          <div class="constTable" v-if="mainHtml.showMathMlExample">
            <h1>试题公式显示示例</h1>
            <div style="margin: 13px 35px 20px 35px">
              试题正文返回的为html标签，直接插入页面html展示即可，具体示例如下：
            </div>
            <div class="code">
              <codemirror v-model="code" :options="cmOption"></codemirror>
            </div>
            <pre id="content">
              {{ content }}
            </pre>
          </div>
          <div class="constTable" v-if="mainHtml.showVodExample">
            <h1>视频播放实例</h1>
            <div style="margin: 13px 35px 20px 35px">
              视频播放采用阿里云点播服务，需调用阿里云播放器
            </div>
            <div class="code">
              <codemirror v-model="vodCode" :options="cmOption"></codemirror>
            </div>
            <pre id="content">
              {{ vodContent }}
            </pre>
          </div>
          <div class="constTable" v-if="mainHtml.showErrorCode">
            <h1>错误码</h1>
          </div>
          <el-table
            v-if="mainHtml.showErrorCode"
            :data="mainHtml.errorCodeTable.tableData"
            header-row-class-name="my-header-row-class"
            border
            style="width: 100%"
          >
            <el-table-column
              v-for="(item, index) in mainHtml.errorCodeTable.tableHead"
              :key="index"
              :prop="item.prop"
              :width="item.width"
              :min-width="item.minWidth"
              :align="item.align"
              :label="item.label"
            >
            </el-table-column>
          </el-table>
          <div class="constTable" v-if="mainHtml.showAutographContent">
            <h1>签名算法步骤</h1>
          </div>
          <div
            class="devdocumentIntroduce showAutographContent"
            v-if="mainHtml.showAutographContent"
            v-html="mainHtml.content1"
          >
          </div>
          <img
            v-if="mainHtml.showTableImg"
            style="display: block"
            src="../../../../assets/images/word/table1.png"
            alt=""
          />
          <div
            class="devdocumentIntroduce showAutographContent"
            v-if="mainHtml.showAutographContent"
            v-html="mainHtml.content2"
          >
          </div>
          <div
            class="devdocumentIntroduce showAutographContent"
            v-if="mainHtml.showAutographContent"
            v-html="mainHtml.content3"
          >
          </div>
          <div
            class="devdocumentIntroduce showAutographContent"
            v-if="mainHtml.showAutographContent"
            v-html="mainHtml.content4"
          >
          </div>
          <div
            class="devdocumentIntroduce showAutographContent"
            v-if="mainHtml.showAutographContent"
            v-html="mainHtml.content5"
          >
          </div>
        </el-main>
      </el-container>
    </el-main>
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/go/go.js";
import "codemirror/mode/php/php.js";
import "codemirror/mode/vb/vb.js";
import "codemirror/mode/python/python.js";
import "codemirror/theme/darcula.css";
import "codemirror/addon/selection/active-line.js";
import { MATH_PAPER_CODE, VOD_PAPER_CODE } from "@/utils/code";
export default {
  name: 'describe',
  components: {
    codemirror
  },
  props: {
    mainHtml: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      code: MATH_PAPER_CODE,
      vodCode: VOD_PAPER_CODE,
      content: MATH_PAPER_CODE,
      vodContent: VOD_PAPER_CODE,
      cmOption: {
        tabSize: 4,
        readOnly: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: "text/x-go",
        lineWrapping: true,
        theme: "darcula",
      },
    }
  },
  methods: {
    copyCode() {
      const range = document.createRange();
      range.selectNode(document.getElementById("content"));
      const selection = window.getSelection();
      if (selection.rangeCount > 0) selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("copy");
      this.$message.success('已复制到剪贴板')
    },
  },
};
</script>

<style lang="scss">

.constTable h1 {
  margin-top: 33px;
  margin-bottom: 23px;
  font-size: 18px;
  font-family: MicrosoftYaHei;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
}
.constTable #content {
  position: absolute;
  top: 0;
  opacity: 0;
}

.constTable .code {
  margin: 13px 35px 35px 35px;
  border-radius: 4px;
}

.constTable .CodeMirror.cm-s-darcula {
  height: 900px;
  border: 1px solid #ebebeb;
  background-color: #f7f7f7;
  color: #666666;
}

.constTable .cm-s-darcula.CodeMirror {
  background-color: #f7f7f7;
  height: auto;
  // min-height: 400px;
}
.constTable .CodeMirror-linenumber {
  color: #666666;
}
.constTable .CodeMirror-linenumber.CodeMirror-gutter-elt,
.constTable .CodeMirror-gutter.CodeMirror-linenumbers {
  background-color: #f7f7f7;
}
.constTable .CodeMirror-gutters {
  border-color: #f7f7f7;
  margin-right: 18px;
  border-right: 1px solid #f7f7f7 !important;
}
.constTable .cm-s-darcula span.cm-variable {
  color: #666666 !important;
}
.constTable .CodeMirror-activeline {
  background-color: #ffffff;
}
.constTable .CodeMirror-activeline .CodeMirror-line {
  /*background-color: #ffffff;*/
  background-color: #f7f7f7;
}
.constTable .el-button--text {
  color: #108ee9;
}
.constTable .el-date-table,
.constTable .el-table th {
  padding: 6px 0;
}
.constTable th,
.constTable td {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/front/documentV2/components/describe.vue